import template from './user-logged.template.html';
import controller from './user-logged.controller';
import './user-logged.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/shared/user-logged/user-logged.component.js